// pages/index/components/DigiFreeModal.tsx
import { Box, Dialog, IconButton, Link, Typography } from "@mui/material";
import { Close, GetApp, Search, Savings } from "@mui/icons-material";
import digifreeHeaderUrl from "@images/digifree_header.png";
interface DigiFreeModalProps {
    open: boolean;
    onClose: () => void;
}

export const DigiFreeModal = ({ open, onClose }: DigiFreeModalProps) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: "24px 24px 16px 16px",
                    p: 3,
                    pt: 5,
                    maxWidth: "500px",
                    position: "relative",
                },
            }}
        >
            {/* Handle bar at the top */}
            <Box
                sx={{
                    width: "80px",
                    height: "4px",
                    backgroundColor: "#E0E0E0",
                    borderRadius: "2px",
                    position: "absolute",
                    top: "12px",
                    left: "50%",
                    transform: "translateX(-50%)",
                }}
            />
            {/* Close Button */}
            <IconButton
                onClick={onClose}
                sx={{
                    position: "absolute",
                    right: 16,
                    top: 16,
                    color: "#757575",
                }}
            >
                <Close />
            </IconButton>

            {/* Header */}
            <Box sx={{ textAlign: "center", mb: 3 }}>
                {/* DigiFree Logo */}
                <Box
                    component="img"
                    src={digifreeHeaderUrl}
                    alt="digiFREE"
                    sx={{
                        maxWidth: "280px",
                        width: "100%",
                        height: "auto",
                        mx: "auto",
                    }}
                />
            </Box>

            {/* Steps */}
            <Box sx={{ mb: 3 }}>
                {/* Step 1 */}
                <Box sx={{ display: "flex", gap: 2, mb: 2.5 }}>
                    <Box
                        sx={{
                            width: 48,
                            height: 48,
                            borderRadius: "50%",
                            backgroundColor: "#DC1E32",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                        }}
                    >
                        <GetApp sx={{ color: "#fff", fontSize: "1.5rem" }} />
                    </Box>
                    <Box>
                        <Typography
                            variant="body1"
                            sx={{ fontWeight: 700, fontSize: "0.875rem", mb: 0.5 }}
                        >
                            1. DOWNLOAD
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{ fontSize: "0.8125rem", color: "#424242" }}
                        >
                            Click below to download the digiFREE app or search the App store.
                        </Typography>
                    </Box>
                </Box>

                {/* Step 2 */}
                <Box sx={{ display: "flex", gap: 2, mb: 2.5 }}>
                    <Box
                        sx={{
                            width: 48,
                            height: 48,
                            borderRadius: "50%",
                            backgroundColor: "#DC1E32",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                        }}
                    >
                        <Search sx={{ color: "#fff", fontSize: "1.5rem" }} />
                    </Box>
                    <Box>
                        <Typography
                            variant="body1"
                            sx={{ fontWeight: 700, fontSize: "0.875rem", mb: 0.5 }}
                        >
                            2. SEARCH
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{ fontSize: "0.8125rem", color: "#424242" }}
                        >
                            Search for Organizations and Events within the app.
                        </Typography>
                    </Box>
                </Box>

                {/* Step 3 */}
                <Box sx={{ display: "flex", gap: 2, mb: 2.5 }}>
                    <Box
                        sx={{
                            width: 48,
                            height: 48,
                            borderRadius: "50%",
                            backgroundColor: "#DC1E32",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                        }}
                    >
                        <Savings sx={{ color: "#fff", fontSize: "1.5rem" }} />
                    </Box>
                    <Box>
                        <Typography
                            variant="body1"
                            sx={{ fontWeight: 700, fontSize: "0.875rem", mb: 0.5 }}
                        >
                            3. START SAVING
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{ fontSize: "0.8125rem", color: "#424242" }}
                        >
                            Get discounts for participating organizers and events for free!
                        </Typography>
                    </Box>
                </Box>
            </Box>

            {/* Website Link */}
            <Box sx={{ textAlign: "center", mb: 2 }}>
                <Link
                    href="https://digi-discounts.com/digi-free"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        color: "#DC1E32",
                        fontWeight: 600,
                        fontSize: "0.875rem",
                        textDecoration: "none",
                        "&:hover": {
                            textDecoration: "underline",
                        },
                    }}
                >
                    Check out digiFREE&apos;s website here
                </Link>
            </Box>
        </Dialog>
    );
};
